<template>
    <div>
        <ol class="app_title">
            <li>
                <i class="fa fa-th"/>
                <router-link tag="a" to="/apps" class="nav_title_a">应用</router-link>
            </li>
            <!--<span class="separator_span"></span>-->
            <li>
                <router-link tag="a" class="nav_title_a" :to="{ path: '/apps/' + data.app_key }">
                    {{ data.app_name }}
                </router-link>
            </li>
            <!--<span class="separator_span"></span>-->
            <li>
                <router-link tag="a" class="nav_title_a" :to="{ path: '/apps/' + data.app_key, params: { id: this.$route.params.id } }">
                    {{ data.page_name }}
                </router-link>
            </li>
        </ol>
    </div>
</template>
<script type="text/javascript">
    export default {
        props: {
            data: {
                type: Object,
                require: true
            }
        }
    }
</script>
<style type="text/css" scoped>
    .app_title {
        display: flex;
        padding: 10px;
        margin: 0 0 0 0;
        color: #a7bdcd;
    }

    .app_title > li > i{
        margin-right: 8px;
    }

    .app_title > li + li:before {
        content: "\00bb\00a0";
        margin-left: 8px;
        color: #ccc;
    }

    .nav_title_a {
        color: #666;
        font-size: 14px;
    }

    .nav_title_a:hover {
        color: #6CF;
    }

    .separator_span {
        padding: 0 5px;
    }

    .separator_span::before {
        content: "/\00a0";
        color: #ccc;
    }

</style>
